import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import queryString from "app/services/queryStringService";
import _ from "lodash";

import { Helmet } from "react-helmet";
import moment from "moment";

import { getrequisition } from "app/services/paymentService";
import HandyScroll from "app/common/Scroll";

const ApprovedReq = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.amount} </span>;
  };
  const transactionModeFormatter = (cell, row) => {
    return <span>{row.transferMethod?.toUpperCase()} </span>;
  };
  const dateFormater = (cell, row) => {
    return moment(cell ? cell : new Date()).format("MMMM Do YYYY, hh:mm a");
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const columns = [
    {
      dataField: "transactionId",
      text: "Transaction Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "fromMember.company",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "referenceNo",
      text: "Ref. Number",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "requestDate",
      text: "Req Date and Time",
      formatter: dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
    },
    {
      dataField: "pgType",
      text: "Req Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transferMethod",
      text: "Payment Mode",
      formatter: transactionModeFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: transactionAmountFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadReq = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      status: "Approved",
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getrequisition(query);
    const TableData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setLoading(false);
    setData(TableData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
  };

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };
  useEffect(() => {
    loadReq();
  }, [page, sizePerPage]);

  return (
    <>
      <Helmet>
        <title>Approved Requisition List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Approved Requisition List" }]}
      ></Breadcrumb>
      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={dataCount > 0 && paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </>
  );
};

export default ApprovedReq;
